import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
  ],
});

export const styles = StyleSheet.create({
  page: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: '100%',
  },
  leftColumn: {
    width: '50%',
    height: '100%',
    backgroundColor: 'white',
    color: 'white',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: 53,
  },
  rightColumn: {
    width: '50%',
    height: '100%',
    backgroundColor: 'white',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: 53,
  },
  title: {
    color: 'black',
    fontFamily: 'Lato',
    fontSize: 40,
    fontWeight: 900,
    textTransform: 'uppercase',
  },

  // Images section
  imageSection: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: 780,
    marginBottom: 20,
  },
  leftImageColumn: {
    width: '36%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  rightImageColumn: {
    width: '64%',
    display: 'flex',
    justifyContent: 'space-between',
  },
  leftTopImage: {
    width: 260,
    height: 260,
    objectFit: 'cover',
    borderRadius: '5px',
  },
  leftBottomImage: {
    width: 200,
    height: 350,
    objectFit: 'cover',
    borderRadius: '5px',
  },
  rightTopImage: {
    width: '100%',
    height: 400,
    objectFit: 'cover',
    borderRadius: '5px',
  },
  rightBottomImage: {
    width: '100%',
    height: 250,
    objectFit: 'fill',
    borderRadius: '5px',
  },
  smallImageSpacer: {
    height: 27,
  },

  keyTopicsListTitle: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 18,
    marginTop: 20,
    marginBottom: 20,
  },
  keyTopicsListWrapper: {
    width: '90%',
  },
  keyTopicsListItemWrapper: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 4,
  },
  keyTopicsText: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 13,
    marginBottom: 4,
  },
});
